module.exports = __webpack_public_path__ + "static/media/lunch3.bd8a83db.jpg";